module.exports = __webpack_public_path__ + "media/flags/sz-5e362aa3.svg";